import axios from 'axios'
import {
  Message
} from 'element-ui'
import {
  getToken
} from './auth'
import router from '@/router/premission.js'
import {
  removeToken
} from '@/utils/auth.js'
const service = axios.create({
  baseURL: process.env.BASE_API,
  timeout: 60000
})
service.interceptors.request.use(config => {
  config.headers['token'] = getToken()
  config.headers['Client'] = 'PC'

  return config
}, error => {
  console.log(error)
  Promise.reject(error)
})
service.interceptors.response.use(response => {
  if (response.data.errcode && (response.data.errcode === 4012 || response.data.errcode === 4040 || response.data.errcode === 4030)) {
    Message({
      message: '用户信息失效，请重新登陆',
      type: 'error',
      duration: 2 * 1000
    })
    // debugger
    setTimeout(() => {
      removeToken()
      localStorage.removeItem('commercialId')
      localStorage.removeItem('commLevel')
      if (!window.location.href.includes('login')) {
        router.push({
          name: 'login'
        })
        window.location.reload()
      }
    }, 2500)
    return Promise.reject(response.data.errmsg)
  } else if (response.data.errcode === 0) {
    return response.data
  } else {
    let errmsg = response.data.errmsg
    if (response.data.errcode === 4011) errmsg = '账号或密码错误'
    if (response.data.errcode === 4019) errmsg = '账号已被停用 '
    Message({
      message: errmsg,
      type: 'error',
      duration: 2 * 1000
    })
    return Promise.reject(response.data.errmsg)
  }
}, error => {
  Message({
    message: '系统繁忙，请联系管理员。',
    type: 'error',
    duration: 2 * 1000
  })
  return Promise.reject(error)
})
export default service



// WEBPACK FOOTER //
// ./src/utils/request.js